import { render, staticRenderFns } from "./CommissionItem.vue?vue&type=template&id=bc160508&scoped=true"
import script from "./CommissionItem.vue?vue&type=script&lang=js"
export * from "./CommissionItem.vue?vue&type=script&lang=js"
import style0 from "./CommissionItem.vue?vue&type=style&index=0&id=bc160508&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc160508",
  null
  
)

export default component.exports